export const batchArray = <T>(arr: T[], len: number): T[][] => {
  return arr.reduce((prev, next, index) => {
    if (!prev.length || prev[prev.length - 1].length == len) {
      return [...prev, [next]];
    } else {
      return [
        ...prev.slice(0, prev.length - 1),
        [...prev[prev.length - 1], next],
      ];
    }
  }, [] as T[][]);
};
